// Presentation helpers for the Verification queue (spec 026 V2).
//
// The pending filter mirrors the attention tile's rule (dataService.getAttentionCounts,
// spec 024 D7): docs that actually carry verifyStatus "pending", not legacy docs missing
// the field. It also accepts the legacy field spelling `verify_status` — the same aliasing
// Tutors.js's own verifyFilter already uses — so a teacher written before the rename still
// shows up in the queue.

export const getVerifyStatus = (teacher) =>
  (teacher && (teacher.verifyStatus || teacher.verify_status)) || "";

export const isPendingVerification = (teacher) =>
  getVerifyStatus(teacher) === "pending";

export const filterPendingTeachers = (teachers) =>
  (teachers || []).filter(isPendingVerification);

// Certificates as the app writes them (121islamapp's teacherOnboarding.js):
// { id, name, organization, startYear, endYear, year, fileUrl }. Tolerates
// missing/empty — a teacher who hasn't uploaded one yet has certificates: [].
export const visibleCertificates = (teacher) =>
  Array.isArray(teacher && teacher.certificates) ? teacher.certificates : [];

// One row for the queue table + drawer. Normalizes the shapes name/subjects
// can arrive in — same aliasing Tutors.js already applies to this collection.
export const toVerificationRow = (teacher) => ({
  id: teacher.id,
  name: teacher.name || teacher.fullName || teacher.displayName || teacher.id,
  email: teacher.email || "",
  phone: teacher.phone || teacher.phone_number || "",
  subjects: Array.isArray(teacher.subjects)
    ? teacher.subjects
    : teacher.subjects
    ? [teacher.subjects]
    : [],
  bio: teacher.bio || "",
  certificates: visibleCertificates(teacher),
  verifyStatus: getVerifyStatus(teacher) || "pending",
  // The Approve dialog prefills the hourly rate from any the tutor already has (026 D22);
  // anything that is not a rate above zero reads as "none" so such a tutor starts at the
  // default rate instead (approvalRate, 047 D89).
  salary: Number(teacher.salary) > 0 ? Number(teacher.salary) : null,
});

// The Approve dialog's starting rate (047 D89): the tutor's own rate when they have one (026 D22),
// else E£150, the rate every tutor earns since the 26 Aug cycle. A string, for the text field.
export const DEFAULT_TUTOR_RATE = 150;
export const approvalRate = (row) => String(Number(row?.salary) > 0 ? Number(row.salary) : DEFAULT_TUTOR_RATE);
